// routesConfig.js
import UserProfile from "../Admin/Profile";
import TeamsTree from '../Admin/TeamsTree'

import AdminDashboard from "../Admin/Dashboard";
import AdminBanners from "../Admin/Banners/Banners";
import AdminBanners50 from "../Admin/Banners50/Banners";
import AdminProducts from "../Admin/Products/Products";
import AdminTestimonials from "../Admin/Testimonials/Testimonials";
import AdminBlogs from "../Admin/Blogs/Blogs";
import AdminAffiliates from "../Admin/AdminAffiliates/AdminAffiliates";
import AdminOrders from "../Admin/Orders/Orders";
import AdminEncashments from "../Admin/Encashments/Encashments";

import DistributorDashboard from "../Distributor/Dashboard/Dashboard";
// import DistributorSaleHistory from "../Distributor/SaleHistory/SaleHistory";
import DistributorTeams from "../Distributor/Teams/Teams";


// Example: every route now also has `label` and `icon` (for sidebar)
export const routesConfig = [
  // 🔹 User Routes (common)
  { path: "/profile", element: <UserProfile />, roles: ["admin","distributor"], label: "Profile", icon: "bi-house-door" },
  { path: "/teams-tree", element: <TeamsTree />, roles: ["admin","distributor"], label: "Network", icon: "bi-house-door" },

  // 🔹 Admin Routes
  { path: "/dashboard", element: <AdminDashboard />, roles: ["admin"], label: "Dashboard", icon: "bi-house-door" },
  { path: "/banners", element: <AdminBanners />, roles: ["admin"], label: "Banners", icon: "bi-image" },
  { path: "/banners50", element: <AdminBanners50 />, roles: ["admin"], label: "Banners50", icon: "bi-layers" },
  { path: "/products", element: <AdminProducts />, roles: ["admin"], label: "Products", icon: "bi-box-seam" },
  { path: "/testimonials", element: <AdminTestimonials />, roles: ["admin"], label: "Testimonials", icon: "bi-chat-square-quote" },
  { path: "/blogs", element: <AdminBlogs />, roles: ["admin"], label: "Blogs", icon: "bi-journal-text" },
  { path: "/affiliates", element: <AdminAffiliates />, roles: ["admin"], label: "Affiliates", icon: "bi-people" },
  { path: "/orders", element: <AdminOrders />, roles: ["admin"], label: "Orders", icon: "bi-cart" },
  { path: "/encashments", element: < AdminEncashments/>, roles: ["admin","distributor"], label: "Encashments", icon: "bi-clock-history" },

  // 🔹 Distributor Routes
  { path: "/dist/dashboard", element: <DistributorDashboard />, roles: ["distributor"], label: "Dashboard", icon: "bi-speedometer2" },
  { path: "/sale-history", element: <AdminOrders />, roles: ["distributor"], label: "Sale History", icon: "bi-receipt" },
  { path: "/teams", element: <DistributorTeams />, roles: ["distributor"], label: "Teams", icon: "bi-people" },
  // { path: "/transections", element: <DistributorTeams />, roles: ["distributor"], label: "Transections", icon: "bi-people" },
];
